import { classNames } from '@/utils/ui/classname';
import styles from './iconfont.module.scss';
import { memo } from 'react';

interface IconFontProps extends React.SVGProps<SVGSVGElement> {
  iconName: string;
}

export const IconFont = memo(({ className, iconName, ...props }: IconFontProps) => {
  return (
    <svg className={classNames(styles.iconfont, className)} aria-hidden="true" {...props}>
      <use xlinkHref={`#${iconName}`}></use>
    </svg>
  );
});

IconFont.displayName = 'IconFont';
